import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createScenarioEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackScenarioOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCENARIO_OPEN,
      properties: { source },
    });

  const trackScenarioRan = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCENARIO_RAN,
      properties: { source },
    });

  return { trackScenarioOpen, trackScenarioRan };
};
